<template>
  <div class="my-order" ref="container">
    <div class="header bg-color-red" style="height: 1rem">
      <div class="picTxt acea-row row-between-wrapper" style="height: 1rem;display: block;">
        <div style="text-align: center">
          <p style="line-height: 1rem;font-size: 0.4rem;font-weight:600;color: #fff">兑换核销码</p>
        </div>
      </div>
    </div>

    <div class="list">
      <div class="item" v-for="order in orderList" :key="order.id">
        <div class="title acea-row row-between-wrapper">
          <div class="acea-row row-middle">
            <span
              class="sign cart-color acea-row row-center-wrapper"
              v-if="order.combination_id > 0"
            >拼团</span>
            <span class="sign cart-color acea-row row-center-wrapper" v-if="order.seckill_id > 0">秒杀</span>
            <span class="sign cart-color acea-row row-center-wrapper" v-if="order.bargain_id > 0">砍价</span>
            {{ order.title }}
          </div>
        </div>

        <div>
          <div class="item-info acea-row row-between row-top">
            <div class="pictrue">
              <img :src="order.img" />
            </div>

            <div class="text acea-row row-between">
              <div class="name line2">
                {{ order.store_name }}
                <br />
                {{ order.store_info }}
              </div>
            </div>
          </div>
        </div>

        <div class="totalPrice">
          订单号：{{ order.order_id }}
          <br />
          到期时间：{{ order.coupons_time2 }}
        </div>
      </div>
    </div>

    <div style="height: 1.5rem"></div>

    <div class="dibu">
      <div style="width: 59%">共{{ orderList.length }}张</div>
      <div
        class="button"
        style="width: 40%;background: #ff5a60;border-radius: 1rem;height: 0.8rem;margin: 0.1rem auto;line-height: 0.8rem;"
        @click="Duihuan"
      >放入卡包</div>
    </div>
  </div>
</template>

<script>
import { getOrderToExchangeLest } from "@api/coupons";

import { cancelOrderHandle, takeOrderHandle } from "@libs/order";
import Payment from "@components/Payment";
import { mapGetters } from "vuex";
import { isWeixin } from "@utils";

const NAME = "OrderExchange";

export default {
  name: NAME,
  data() {
    return {
      offlinePayStatus: 2,
      orderData: {},
      type: parseInt(this.$route.params.type) || 0,
      loading: false,
      orderList: [],
      order_id: this.$route.params.order || 0
    };
  },
  components: {
    //组件注册
    Payment
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    //检测路由改变
    $route(n) {
      if (n.name === NAME) {
        const order_id = this.$route.params.order || 0;
        console.log("新的order_id");
        console.log(order_id);
        console.log(this.order_id !== order_id);
        if (this.order_id !== order_id) {
          this.changeorder(order_id);
        }
        this.getDuihuanLesr();
      }
    }
  },

  methods: {
    //函数定义
    /**
     * 获取兑换核销码信息
     */
    getDuihuanLesr() {
      if (this.loading) return;
      this.loading = true;
      const { order_id } = this;
      getOrderToExchangeLest({ order_id, type: 0 }).then(res => {
        console.log(res.data);
        this.orderList = this.orderList.concat(res.data);
      });
    },

    /**
     * 兑换核销码
     * @param order
     */
    Duihuan() {
      this.$dialog.loading.open("领取中");
      const { order_id } = this;
      getOrderToExchangeLest({ order_id, type: 1 })
        .then(res => {
          this.$dialog.loading.close();
          this.$dialog.success(res.msg);
          this.$router.go(-1);
        })
        .catch(() => {
          this.$dialog.loading.close();
          this.$dialog.error(res.msg);
        });
    },

    takeOrder(order) {
      takeOrderHandle(order.order_id).finally(() => {
        this.reload();
        this.getDuihuanLesr();
      });
    },

    reload() {
      this.changeType(this.type);
    },

    changeorder(order_id) {
      this.type = 0;
      this.order_id = order_id;
      this.orderList = [];
      this.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getDuihuanLesr();
    },

    //获取状态文字
    getStatus(order) {
      return STATUS[order._status._type];
    },

    cancelOrder(order) {
      cancelOrderHandle(order.order_id)
        .then(() => {
          this.orderList.splice(this.orderList.indexOf(order), 1);
        })
        .catch(() => {
          this.reload();
        });
    }
  },
  mounted() {
    //初始化方法
    console.log(this.order_id);
    this.getDuihuanLesr(); //获取列表
  }
};
</script>

<style scoped>
.dibu {
  height: 1rem;
  position: fixed;
  bottom: 0px;
  background: #fff;
  font-size: 0.3rem;
  width: 100%;
  text-align: center;
  line-height: 1rem;
}

.dibu .button {
  float: left;
  font-size: 0.3rem;
  color: #fff;
}

.dibu div {
  float: left;
}
</style>
